import React, { useId } from "react";
import {
  SCOREBOARD_THEMES,
  scoreboardThemeName,
} from "../constants/scoreboardThemes";
import "./ScoreboardAppearance.css";
import ScoreboardFrame from "./ScoreboardFrame";

export function ScoreboardThemePreview({ theme }) {
  return (
    <div
      className={`sb-theme-preview sb-theme-preview--${theme}`}
      aria-hidden="true"
    >
      <ScoreboardFrame variant={theme} />
      <div className="sb-preview-top">
        <span>
          <ScoreboardFrame
            variant={theme === "premium" ? theme : null}
            detail="panel"
          />
          TABLE 1
        </span>
        <span>
          <ScoreboardFrame
            variant={theme === "premium" ? theme : null}
            detail="panel"
          />
          00:12:38
        </span>
      </div>
      <div className="sb-preview-players">
        <span>PLAYER A</span>
        <b>1</b>
        <small>FRAMES</small>
        <b>0</b>
        <span>PLAYER B</span>
      </div>
      <div className="sb-preview-scores">
        <strong className="sb-preview-active">
          <ScoreboardFrame
            variant={theme === "premium" ? theme : null}
            detail="panel"
          />
          38
        </strong>
        <small>SCORE</small>
        <strong>
          <ScoreboardFrame
            variant={theme === "premium" ? theme : null}
            detail="panel"
          />
          24
        </strong>
      </div>
      <div className="sb-preview-break">BREAK: 16</div>
      <div className="sb-preview-bottom">
        REMAINING: 83 <span>HISTORY</span>
      </div>
    </div>
  );
}

export default function ScoreboardThemePicker({
  value,
  onChange,
  allowInherit = false,
  clubTheme = "modern-dark",
  disabled = false,
}) {
  const group = useId();
  return (
    <fieldset className="sb-theme-picker" disabled={disabled}>
      <legend className="sb-sr-only">Choose a scoreboard design</legend>
      {allowInherit && (
        <label
          className={`sb-theme-inherit ${value == null ? "is-selected" : ""}`}
        >
          <input
            type="radio"
            name={group}
            checked={value == null}
            onChange={() => onChange(null)}
          />
          <span>
            <strong>Follow club default</strong>
            <small>
              Currently {scoreboardThemeName(clubTheme)}. Future club changes
              apply here too.
            </small>
          </span>
          <span className="sb-theme-tag">Recommended</span>
        </label>
      )}
      <div className="sb-theme-grid">
        {SCOREBOARD_THEMES.map((theme) => (
          <label
            key={theme.id}
            className={`sb-theme-option ${
              value === theme.id ? "is-selected" : ""
            }`}
          >
            <input
              type="radio"
              name={group}
              checked={value === theme.id}
              onChange={() => onChange(theme.id)}
              aria-label={theme.name}
            />
            <ScoreboardThemePreview theme={theme.id} />
            <span className="sb-theme-caption">
              <span>
                <strong>{theme.name}</strong>
                <small>{theme.description}</small>
              </span>
              <span className="sb-theme-check" aria-hidden="true">
                {value === theme.id ? "✓" : ""}
              </span>
            </span>
            <span className="sb-theme-tone">{theme.tone}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
